import { MutableRefObject, useEffect } from 'react';

interface UseClickOutsideOptions {
  refs: MutableRefObject<HTMLElement>[] | MutableRefObject<HTMLElement>;
  unless?: boolean | ((e: globalThis.MouseEvent) => boolean);
  onClick: (e: globalThis.MouseEvent) => void;
}

export default function useClickOutside({
  refs,
  unless = false,
  onClick,
}: UseClickOutsideOptions) {
  const refsAsArray = Array.isArray(refs) ? refs : [refs];

  useEffect(() => {
    function handleOutsideClick(e: globalThis.MouseEvent) {
      const allRefsHaveCurrent = refsAsArray.every((ref) => !!ref.current);
      const shouldNotExecute = typeof unless === 'function' ? unless(e) : unless;

      if (!allRefsHaveCurrent || shouldNotExecute) {
        return;
      }

      const isOutsideClick = refsAsArray.every((ref) => !ref.current.contains(e.target as Node));

      if (isOutsideClick) {
        onClick(e);
      }
    }

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [unless, onClick, refs]);
}
